import { ArrowLeft, Loader2 } from 'lucide-react'
import { useLanguage } from '@/hooks/useLanguage'
import { betaT } from '../locale'
import type { BetaUseCase } from '../betaApi'

const ORDER: BetaUseCase[] = ['publish', 'audience', 'employees', 'knowledge', 'explore']

interface Props {
  useCase: BetaUseCase | null
  setUseCase: (v: BetaUseCase) => void
  isSubmitting: boolean
  onBack: () => void
  onSubmit: () => void
}

export const BetaSurvey = ({ useCase, setUseCase, isSubmitting, onBack, onSubmit }: Props) => {
  const { language } = useLanguage()
  const l = betaT[language]

  // white by design: renders on the fixed-dark Beta hero (BetaLayout), not app surface
  return (
    <>
      <button
        type="button"
        onClick={onBack}
        className="flex items-center gap-1 text-sm text-white/50 hover:text-white/80 transition-colors mb-4"
      >
        <ArrowLeft className="w-4 h-4" />
        {l.back}
      </button>
      <h2 className="text-xl sm:text-2xl font-semibold text-white mb-2">{l.surveyTitle}</h2>
      <div className="space-y-3 mt-8 mb-6">
        {ORDER.map((id) => {
          const selected = useCase === id
          return (
            <button
              key={id}
              type="button"
              onClick={() => setUseCase(id)}
              className={`w-full text-left px-4 py-3.5 rounded-xl border transition-all text-sm ${
                selected
                  ? 'border-white bg-white/10 text-white font-medium'
                  : 'border-white/10 bg-white/5 text-white/70 hover:border-white/20 hover:bg-white/10'
              }`}
            >
              {l.options[id]}
            </button>
          )
        })}
      </div>
      <button
        type="button"
        onClick={onSubmit}
        disabled={!useCase || isSubmitting}
        className="w-full h-11 rounded-xl bg-white hover:bg-white/90 text-[#0E0E12] font-medium text-sm transition-all duration-200 hover:scale-[1.02] disabled:opacity-50 disabled:pointer-events-none flex items-center justify-center gap-2"
      >
        {isSubmitting ? (
          <>
            <Loader2 className="w-4 h-4 animate-spin" />
            {l.sending}
          </>
        ) : (
          l.submit
        )}
      </button>
    </>
  )
}
